<template>
  <vue-final-modal v-slot="{ close }">
    <div class="loginmodal alert-backdrop">
      <div class="art" :class="level" role="dialog" aria-modal="true">
        <span class="status-icon" aria-hidden="true">
          {{ level === 'warningart' ? '!' : type === 'confirm' ? '?' : 'i' }}
        </span>
        <p class="alert-message" v-html="$t(code)"></p>
        <div class="btn">
          <template v-if="type == 'confirm'">
            <button class="yes" @click="$emit('confirm', 'yes', close)">{{$t('front.button.yes')}}</button>
            <button class="no" @click="$emit('confirm', 'no', close)">{{$t('front.button.no')}}</button>
          </template>
          <template v-if="type == 'check'">
            <button class="yes" @click="$emit('check', 'ok', close)">{{$t('front.button.confirm')}}</button>
          </template>
        </div>
        <button class="closeart" type="button" aria-label="close" @click="onClose(close)">×</button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
import Alert from '@/components/common/Alert'

export default {
  name: 'AlertMobile',
  mixins: [Alert]
}
</script>

<style scoped>
button {font: inherit;cursor: pointer;}
.loginmodal.alert-backdrop {display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;padding: 16px;box-sizing: border-box;overflow: hidden;background: rgba(0, 0, 0, 0.76);}
.art {position: relative;box-sizing: border-box;width: 100%;max-width: 360px;margin: 0;padding: 28px 20px 20px;text-align: center;border: 1px solid rgba(255, 255, 255, 0.1);border-radius: 10px;box-shadow: 0 14px 36px rgba(0, 0, 0, 0.36);background: #151515;color: #f1f1f1;}
.status-icon {display: flex;align-items: center;justify-content: center;width: 32px;height: 32px;margin: 0 auto 16px;border: 1px solid #8a7042;border-radius: 50%;color: #b6a06a;font-size: 16px;font-weight: 700;line-height: 1;}
.warningart .status-icon {border-color: #8d625f;color: #c8908b;}
.art .alert-message {margin: 0;color: #e5e5e5;font-size: 14px;font-weight: 500;line-height: 1.6;word-break: keep-all;overflow-wrap: anywhere;}
.art .btn {display: flex;justify-content: center;gap: 8px;margin-top: 22px;}
.art .yes, .art .no {box-sizing: border-box;width: 100%;height: 42px;padding: 0 14px;border-radius: 7px;font-size: 14px;font-weight: 600;text-shadow: none;}
.art .yes {border: 1px solid #8a7042;background: #8a7042;color: #f7f3eb;}
.art .no {border: 1px solid #333;background: #202020;color: #b8b8b8;}
.closeart {position: absolute;right: 10px;top: 8px;width: 30px;height: 30px;padding: 0;border: 0;background: transparent;color: #777;font-size: 24px;font-weight: 300;line-height: 28px;}
</style>
<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
